import { render, staticRenderFns } from "./JobsByStatusPieGraph.vue?vue&type=template&id=62724f78"
import script from "./JobsByStatusPieGraph.vue?vue&type=script&lang=ts"
export * from "./JobsByStatusPieGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports